import * as _4 from 'lodash4';

export class TodoRefreshService {
  public text: string;
  public show: boolean;

  constructor(private getAdaptivePathChangesCommand: any) {
    this.reset();
  }

  showWithText(text: string): void {
    this.text = text;
    this.show = true;
  }

  reset() {
    this.text = '';
    this.show = false;
  }

  checkForUpdates() {
    return this.getAdaptivePathChangesCommand().then((response: any) => {
      if (response.adaptivePathChanges > 0) {
        this.showWithText(
          `${response.adaptivePathChanges} Update${_4.size(response.adaptivePathChanges) <= 1 ? '' : 's'} Available`
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/services/todo_refresh_service.ts